import {
    AfterContentInit,
    AfterViewInit,
    ContentChild,
    Directive,
    Input,
    OnDestroy,
    ViewChild
} from '@angular/core';
import { PopoverTriggerDirective } from './popover-trigger.directive';
import { PopoverDirective } from './popover.directive';
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { pipe, Subject } from 'rxjs';
import { AbstractControl } from '@angular/forms';

@Directive({
    selector: '[appPopoverContainer]'
})
export class PopoverContainerDirective implements AfterContentInit, OnDestroy {
    unsubscribe$ = new Subject();
    @Input() control: AbstractControl;
    @ContentChild(PopoverTriggerDirective) trigger: PopoverTriggerDirective;
    @ContentChild(PopoverDirective) popover: PopoverDirective;
    constructor() {}
    ngAfterContentInit() {
        this.trigger.$isExpanded
            .pipe(
                tap((isExpanded) =>
                    isExpanded
                        ? this.popover.open(this.trigger.elRef)
                        : this.popover.close()
                ),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();

        this.popover.$isOpen
            .pipe(
                tap((isOpen) =>
                    isOpen ? this.trigger.expand() : this.trigger.collapse()
                ),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
